<banta-chat [topicID]="identifier"></banta-chat>